import { type RawContainer, type ShipmentContainer } from '../domain/ShipmentContainer'

export function mapApiToContainer(container?: RawContainer): ShipmentContainer | undefined {
  if (!container) {
    return
  }
  return {
    containerNumber: container.container_number,
    oceanLineScac: container.ocean_line_scac,
    masterBOLNumber: container.master_bol_number,
    direction: container.direction,
    status: container.status,
    containerSize: container.container_size,
    sealNumber: container.seal_number,
    vesselETA: container.vessel_eta,
    vesselName: container.vessel_name,
    voyageNumber: container.voyage_number,
    imoCode: container.imo_code,
  }
}
